document.addEventListener('DOMContentLoaded', () => {
    const fullSwiper = new Swiper('.full-slider_swiper', {
        loop: true,
        speed: 800,
        navigation: {
            nextEl: ".full-slider_next",
            prevEl: ".full-slider_prev",
        },
        pagination: {
			el: ".full-slider_dots",
			clickable: true,
		},
        breakpoints: {
			300: {
				slidesPerView: 1
			},
			900: {
				slidesPerView: "auto",
                spaceBetween: 100,
                centeredSlides: true
			}
        }
    });
    
    const sliderSwiper = new Swiper('.slider-swiper', {
        loop: true,
        speed: 800,
        slidesPerView: 1,
        navigation: {
            nextEl: ".slider-next",
            prevEl: ".slider-prev",
        },
        effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
        pagination: {
			el: ".slider-dots",
			clickable: true,
		}
    });

    const imgSwiper = new Swiper('.img-swiper', {
        loop: true,
        speed: 800,
        slidesPerView: 1,
        navigation: {
            nextEl: ".img-next",
            prevEl: ".img-prev",
        },
        effect: "fade",
		fadeEffect: {
			crossFade: true,
		}
    });
});